import DoubleSlider from './_DoubleSlider.js';
import { jsx } from 'react/jsx-runtime';

var MAX_GUEST_RATING = 5;
var MIN_GUEST_RATING = 3;
var defaultProps = {
  lowValue: MIN_GUEST_RATING,
  highValue: MAX_GUEST_RATING,
  hidden: false,
  filterSliderToLabel: '',
  onChangeComplete: function onChangeComplete() {}
};
var decimalCommaFormatter = function decimalCommaFormatter(value) {
  var parts = value.toFixed(1).split('.');
  return "".concat(parts[0], ",").concat(parts.length === 1 ? '0' : parts[1]);
};
var GuestRatingSlider = function GuestRatingSlider(_ref) {
  var onChangeComplete = _ref.onChangeComplete,
    filterSliderToLabel = _ref.filterSliderToLabel,
    lowValue = _ref.lowValue,
    highValue = _ref.highValue,
    hidden = _ref.hidden;
  if (typeof onChangeComplete !== 'function' || !filterSliderToLabel) {
    return false;
  }
  return /*#__PURE__*/jsx(DoubleSlider, {
    min: MIN_GUEST_RATING,
    max: MAX_GUEST_RATING,
    step: 0.1,
    lowValue: lowValue,
    highValue: highValue,
    separationLimit: 0.2,
    format: decimalCommaFormatter,
    filterSliderToLabel: filterSliderToLabel,
    onChangeComplete: onChangeComplete,
    hidden: hidden
  });
};
GuestRatingSlider.defaultProps = defaultProps;
var GuestRatingSlider$1 = GuestRatingSlider;

export { GuestRatingSlider$1 as default };
//# sourceMappingURL=GuestRatingSlider.js.map
